import Vue from "vue";
import emailValidation from "./helpers/email_validation";

const newsletter = {
  data() {
    return {
      email: "",
      emailValid: null,
      rodo: false,
      rodoValid: null,
      formSending: false,
      formSendSuccess: false,
      formSendFailure: false,
    };
  },
  delimiters: ["${", "}"],
  methods: {
    async postData(url, formData) {
      const response = await fetch(url, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      });
      return response.json();
    },
    sendForm(e) {
      const { postData } = this;
      e.preventDefault();
      grecaptcha.ready(function () {
        grecaptcha
          .execute("6Lc2cGkfAAAAADjEvtBSJCpTpXw3UKOW_efOjUN2", {
            action: "submit",
          })
          .then(function (token) {
            const formData = new FormData();
            formData.append("token", token);
            if (token) {
              postData("/api/validate/captcha", formData).then(
                ({ response }) => {
                  if (response.success && response.score > 0.8) {
                    e.target.submit();
                  }
                }
              );
            }
          });
      });
    },
    emailValidation(e) {
      const email = e.target.value;
      this.emailValid = emailValidation(email);
    },

    rodoValidation() {
      !this.rodo ? (this.rodoValid = false) : (this.rodoValid = true);
    },

    submit(e) {
      const btn = e.target;
      const form = btn.closest("form");
      const action = form.action;

      !this.email ? (this.emailValid = false) : false;
      !this.rodo ? (this.rodoValid = false) : false;

      if (!this.emailValid || !this.rodoValid) {
        return;
      }

      const data = {
        email: this.email,
        attribute4: "on",
      };

      const request = new Request(action, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `email=${this.email}&attribute4=on&list[8]=signup&listname[8]=Newsletter STS&htmlemail=1&VerificationCodeX`,
      });

      fetch(request)
        .then()
        .then((json) => {
          this.formSendSuccess = true;
          this.formSending = false;
        })
        .catch((error) => {
          this.formSendFailure = true;
          this.formSending = false;

          console.error(error);
        });

      this.formSending = true;
    },
  },
};

export default newsletter;



// WEBPACK FOOTER //
// ./assets/js/partials/newsletter.js